//* 公共组件
import type { GeneticInformation } from "@/components/models";
//* 组件属性
import type { ModuleProps } from "../index";
import { useOptions } from "./options";

export const useComposable = (define: ModuleProps) => {
    //* 配置项
    const options = useOptions(define);

    //* 节点
    const nodes = {
        container: ref<HTMLDivElement>(),
        visualization: ref<InstanceType<typeof GeneticInformation>>(),
    };

    return { nodes, options };
};
